import createAxiosInstance from './axiosConfig';
import { FaturaDTO, StatusFatura } from '../shared/dto/faturaDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

// Base URL já inclui o caminho do controller
const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/faturasController');

export default class FaturaService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  /**
   * Lista todas as faturas.
   */
  async listarFaturas(filtros: any) {
    const params = new URLSearchParams();
    
    if (filtros.dataInicio) params.append('inicio', filtros.dataInicio);
    if (filtros.dataFim) params.append('fim', filtros.dataFim);
    if (filtros.status) params.append('status', filtros.status);
    if (filtros.termoBusca) params.append('busca', filtros.termoBusca);

    // --- CORREÇÃO AQUI ---
    // Mudamos de '/' para '' (vazio) para evitar o Trailing Slash que causa 404 no Spring Boot 3
    return await this.axios.get('', { params });
  }

  /**
   * Busca uma fatura específica pelo ID.
   */
  async buscarDetalhes(idFatura: number) {
    return await this.axios.get(`/${idFatura}`);
  }

  /**
   * Gera faturas manualmente por período.
   */
  async emitirFaturaManual(inicio: string, fim: string) {
    const params = new URLSearchParams();
    params.append('inicio', inicio); 
    params.append('fim', fim);

    return await this.axios.post('/gerar-lote', null, { params });
  }

  /**
   * Atualiza o status da fatura.
   */
  async atualizarStatus(idFatura: number, novoStatus: StatusFatura, observacao?: string) {
    const params = new URLSearchParams();
    params.append('status', novoStatus);
    
    if (observacao) params.append('observacao', observacao);

    return await this.axios.patch(`/${idFatura}/status`, null, { params });
  }

  /**
   * Edita dados da fatura.
   */
  async editarFatura(idFatura: number, dadosEdicao: any) {
    return await this.axios.put(`/${idFatura}`, dadosEdicao);
  }

  /**
   * Realiza o download de arquivos.
   */
  async baixarArquivo(idFatura: number, tipo: 'PDF' | 'EXCEL' | 'CNAB240' | 'CNAB400') {
    let endpoint = '';
    let extensao = '';

    if (tipo === 'PDF') {
      endpoint = `/${idFatura}/pdf`;
      extensao = 'pdf';
    } else if (tipo === 'EXCEL') {
      endpoint = `/${idFatura}/csv`;
      extensao = 'csv';
    } else {
      endpoint = `/${idFatura}/cnab?layout=${tipo}`;
      extensao = 'rem';
    }

    const response = await this.axios.get(endpoint, {
      responseType: 'blob' 
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Fatura_${idFatura}_${tipo}.${extensao}`);
    
    document.body.appendChild(link);
    link.click();
    
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}